import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BudgetAccountDataComponent } from './budget-account-data.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditableFieldModule } from '../editable-field';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { FieldErrorDisplayModule } from '../field-error-display';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { SnackbarModule } from '../../services/snackbar/snackbar.module';

@NgModule({
  declarations: [BudgetAccountDataComponent],
  exports: [BudgetAccountDataComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    EditableFieldModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatCardModule,
    FieldErrorDisplayModule,
    NgSelectModule,
    SnackbarModule,
  ],
})
export class BudgetAccountDataModule {}
